<div class="oxy-section">
  <figure class="logo">
    <img src="img/misc/oxy-logo-modules.png" />
  </figure>
  <span class="phrase"> web + mobile + o que vier </span>
</div>

<div *ngFor="let area of filtra(areas)">
  <div
    *ngIf="hasAnyModulo(area)"
    class="module-box {{ area.cssAdicionalTitulo }}"
  >
    <a
      *ngIf="area.modulos.length == 1"
      href="javascript:void(0)"
      (click)="moduloClick(area.modulos[0])"
    >
      <h2 class="title">
        <div class="container">
          <img
            src="img/modules/{{ area.iconeTituloSmall }}"
            *ngIf="area.modulos[0].id != 90"
          />
          {{ area.modulos[0].descricao }}
        </div>
      </h2>
    </a>

    <div *ngIf="area.modulos.length > 1">
      <h2 class="title">
        <div class="container">
          <img src="img/modules/{{ area.iconeTituloSmall }}" />
          {{ area.iconeTituloSmall }}
        </div>
      </h2>
      <div class="container">
        <ul class="row">
          <div *ngFor="let modulo of area.modulos">
            <li *ngIf="modulo.podeAcessar" class="col-md-4 col-sm-6">
              <a href="javascript:void(0)" (click)="moduloClick(modulo)">
                <b>
                  <img src="img/modules/{{ area.iconeTituloSmall }}" />
                  {{ modulo.descricao }}
                </b>
              </a>
            </li>
          </div>
        </ul>
      </div>
    </div>
  </div>
</div>
